var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 633 633",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 587 573 L 492 603 172 310 194 212 288 182 609 477 587 573 Z M 207 299 C 217 332 252 350 284 340 317 329 335 295 325 262 315 229 280 210 247 221 215 231 197 267 207 299 Z M 484 523 C 490 542 511 553 530 547 549 541 559 521 553 502 547 483 527 472 507 478 488 484 478 504 484 523 Z M 323 329 C 321 331 321 334 323 336 L 388 420 C 389 421 391 422 393 422 393 421 393 421 394 421 395 421 396 420 397 418 L 399 410 467 477 C 469 478 470 478 472 478 473 478 473 477 474 477 476 475 476 472 475 470 L 406 379 C 404 378 402 377 401 377 400 377 400 377 400 377 398 378 397 379 397 381 L 394 391 330 329 C 329 328 327 328 325 328 324 328 324 329 323 329 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 265 433 L 226 445 101 328 139 160 303 110 429 228 420 267 480 323 508 204 322 30 80 104 23 352 208 525 325 489 265 433 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveUnit);
export default __webpack_public_path__ + "static/media/drive-unit.3d22862f45ea84b72816cd2b81fb0aa0.svg";
export { ForwardRef as ReactComponent };